import { createStore } from "vuex";
import {
  applyThemeClasses,
  persistSidebarLightPreference,
  persistThemePreference,
  readSidebarLightPreference,
  readThemePreference,
} from "@/utils/themePreference.js";

const token = localStorage.getItem("token");
const initialDark = readThemePreference();
const initialSidebarLight = readSidebarLightPreference();
applyThemeClasses(initialDark);

export default createStore({
  state: {
    user: null,
    token: token,
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-transparent",
    isRTL: false,
    color: "primary",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: initialDark,
    sidebarLight: initialSidebarLight,
    config: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    showPlanExpiredModal: false,
  },
  mutations: {
    setPlanExpiredModal(state, payload) {
      state.showPlanExpiredModal = payload;
    },
    setDarkMode(state, payload) {
      const next = !!payload;
      state.isDarkMode = next;
      persistThemePreference(next);
      applyThemeClasses(next);
      if (!next) {
        state.sidebarLight = false;
        persistSidebarLightPreference(false);
      }
    },
    toggleDarkMode(state) {
      const next = !state.isDarkMode;
      state.isDarkMode = next;
      persistThemePreference(next);
      applyThemeClasses(next);
      if (!next) {
        state.sidebarLight = false;
        persistSidebarLightPreference(false);
      }
    },
    setSidebarLight(state, payload) {
      const next = !!payload && state.isDarkMode;
      state.sidebarLight = next;
      persistSidebarLightPreference(next);
    },
    toggleSidebarLight(state) {
      if (!state.isDarkMode) return;
      const next = !state.sidebarLight;
      state.sidebarLight = next;
      persistSidebarLightPreference(next);
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    setConfig(state, payload) {
      state.config = payload;
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    color(state, payload) {
      state.color = payload;
    },
    setUser(state, payload) {
      localStorage.setItem("user", JSON.stringify(payload));
      state.user = payload;
    },
    setToken(state, payload) {
      localStorage.setItem("token", payload);
      state.token = payload;
    },
    setAppVersion(state, payload) {
      localStorage.setItem("app_version", payload);
      state.app_version = payload;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.app_version = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("app_version");
      import("@/router").then((router) => {
        router.default.push("/sign-in");
      });
    },
  },
  actions: {
    setColor({ commit }, payload) {
      commit("color", payload);
    },
    logout({ commit }) {
      commit("logout");
    },
  },
  getters: {
    user(state) {
      if (!state.user) {
        const user = localStorage.getItem("user") || null;
        if (user) {
          state.user = JSON.parse(user);
        } else {
          state.user = null;
        }
      }
      return state.user;
    },
    token(state) {
      if (!state.token) {
        const token = localStorage.getItem("token") || null;
        if (token) {
          state.token = token;
        } else {
          state.token = null;
        }
      }
      return state.token;
    },
    app_version(state) {
      if (!state.app_version) {
        const app_version = localStorage.getItem("app_version") || null;
        if (app_version) {
          state.app_version = app_version;
        } else {
          state.app_version = null;
        }
      }
      return state.app_version;
    },
    isDarkMode(state) {
      return state.isDarkMode;
    },
    sidebarLight(state) {
      return state.sidebarLight;
    },
  },
});
